import { takeLatest, put, all, call } from "redux-saga/effects";
// Version : 0.0.1
// Author : sathish
// LastEdit : sathish
// Last ADD :Added Code review changes
// MODIFIED DATE : 03-04-2026
import UserTypeActionTypes from "./userType.types";
import {
  userTypeDetailsAdd,
  userTypeDetailsUpdate,
  userTypeListGet,
  userTypeDetailsFetch,
  userTypeDetailsDelete,
} from "./userType.service";

import {
  addUserTypeDetailsSuccess,
  addUserTypeDetailsFailure,
  addUserTypeDetailsResponseChanged,
  updateUserTypeDetailsSuccess,
  updateUserTypeDetailsFailure,
  updateUserTypeDetailsResponseChanged,
  getUserTypeListSuccess,
  getUserTypeListFailure,
  getUserTypeListResponseChanged,
  fetchUserTypeDetailsSuccess,
  fetchUserTypeDetailsFailure,
  fetchUserTypeDetailsResponseChanged,
  deleteUserTypeDetailsSuccess,
  deleteUserTypeDetailsFailure,
  deleteUserTypeDetailsResponseChanged,
} from "./userType.action";
import { encryptData } from "../../_common/enode-decode";

/** *********************  START GET USERTYPE LIST  ******************** */
export function* userTypeDetailsListGet({ payload }: any) {
  const { CompanyID, searchValueSet, limit, InstanceName } = payload;
  try {
    const key = "GetAllUserTypePaginationKey";
    const jsonData = {
      CompanyID: CompanyID,
      InputSearch: searchValueSet,
      Limit: limit,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(userTypeListGet, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getUserTypeListFailure(responseData.data));
    } else {
      yield put(getUserTypeListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getUserTypeListFailure(error));
  }
}

export function* resetGetUserTypeListResponse() {
  yield put(getUserTypeListResponseChanged());
}

export function* onGetUserTypeListDetails() {
  yield takeLatest(
    UserTypeActionTypes.GET_USERTYPE_LIST_START,
    userTypeDetailsListGet,
  );
}

export function* onGetUserTypeListResponseReset() {
  yield takeLatest(
    UserTypeActionTypes.GET_USERTYPE_LIST_RESPONSE_RESET,
    resetGetUserTypeListResponse,
  );
}
/** *********************  END GET userType LIST ******************** */

/** *********************  START ADD userType DETAILS  ******************** */
export function* createUserType({ payload }: any) {
  const {
    UserTypeName,
    UserTypeLevel,
    CompanyID,
    UserName,
    UserID,
    InstanceName,
  } = payload;
  try {
    const key = "CreateUserTypeKey";
    const jsonData = {
      UserTypeName: UserTypeName,
      UserLevel: UserTypeLevel,
      CompanyID: CompanyID,
      UserName: UserName,
      CreatedBy: UserID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(userTypeDetailsAdd, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(addUserTypeDetailsFailure(responseData.data));
    } else {
      yield put(addUserTypeDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(addUserTypeDetailsFailure(error));
  }
}

export function* resetAddUserTypeResponse() {
  yield put(addUserTypeDetailsResponseChanged());
}

export function* onCreateUserTypeDetails() {
  yield takeLatest(
    UserTypeActionTypes.ADD_USERTYPE_DETAILS_START,
    createUserType,
  );
}

export function* onCreateUserTypeResponseReset() {
  yield takeLatest(
    UserTypeActionTypes.ADD_USERTYPE_DETAILS_RESPONSE_RESET,
    resetAddUserTypeResponse,
  );
}
/** *********************  END ADD USERTYPE DETAILS ******************** */

/** *********************  START UPDATE USERTYPE DETAILS  ******************** */
export function* userTypeUpdate({ payload }: any) {
  const {
    UserTypeID,
    UserTypeName,
    UserTypeLevel,
    oldUserTypeName,
    oldUserTypeLevel,
    CompanyID,
    UserName,
    UserID,
    InstanceName,
  } = payload;
  try {
    const key = "UpdateUserTypeKey";
    const jsonData = {
      UserTypeID: UserTypeID,
      UserTypeName: UserTypeName,
      UserLevel: UserTypeLevel,
      OldUserTypeName: oldUserTypeName,
      OldUserTypeLevel: oldUserTypeLevel,
      CompanyID: CompanyID,
      UserName: UserName,
      UpdatedBy: UserID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(userTypeDetailsUpdate, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updateUserTypeDetailsFailure(responseData.data));
    } else {
      yield put(updateUserTypeDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateUserTypeDetailsFailure(error));
  }
}

export function* resetUpdateUserTypeDetailsResponse() {
  yield put(updateUserTypeDetailsResponseChanged());
}

export function* onUpdateUserTypeDetails() {
  yield takeLatest(
    UserTypeActionTypes.UPDATE_USERTYPE_DETAILS_START,
    userTypeUpdate,
  );
}

export function* onUpdateUserTypeResponseReset() {
  yield takeLatest(
    UserTypeActionTypes.UPDATE_USERTYPE_DETAILS_RESPONSE_RESET,
    resetUpdateUserTypeDetailsResponse,
  );
}
/** *********************  END UPDATE UserType DETAILS ******************** */

/** *********************  START DELETE UserType DETAILS  ******************** */
export function* userTypeDelete({ payload }: any) {
  const {
    CompanyID,
    UserTypeID,
    UserTypeName,
    UserID,
    UserName,
    InstanceName,
  } = payload;
  try {
    const key = "DeleteUserTypeKey";
    const jsonData = {
      CompanyID: CompanyID,
      UserTypeID: UserTypeID,
      UserTypeName: UserTypeName,
      DeletedBy: UserID,
      UserName: UserName,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(userTypeDetailsDelete, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(deleteUserTypeDetailsFailure(responseData.data));
    } else {
      yield put(deleteUserTypeDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(deleteUserTypeDetailsFailure(error));
  }
}

export function* resetDeleteUserTypeDetailsResponse() {
  yield put(deleteUserTypeDetailsResponseChanged());
}

export function* onDeleteUserTypeDetail() {
  yield takeLatest(
    UserTypeActionTypes.DELETE_USERTYPE_DETAILS_START,
    userTypeDelete,
  );
}

export function* onDeleteUserTypeResponseReset() {
  yield takeLatest(
    UserTypeActionTypes.DELETE_USERTYPE_DETAILS_RESPONSE_RESET,
    resetDeleteUserTypeDetailsResponse,
  );
}
/** *********************  END DELETE USERTYPE DETAILS ******************** */

/** *********************  START FETCH USERTYPE DETAILS  ******************** */
export function* fetchUserTypeData({ payload }: any) {
  const { CompanyID, UserTypeID, InstanceName } = payload;
  try {
    const key = "GetUserTypeKey";
    const jsonData = {
      CompanyID: CompanyID,
      UserTypeID: UserTypeID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(userTypeDetailsFetch, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchUserTypeDetailsFailure(responseData.data));
    } else {
      yield put(fetchUserTypeDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchUserTypeDetailsFailure(error));
  }
}

export function* resetFetchUserTypeDetailsResponse() {
  yield put(fetchUserTypeDetailsResponseChanged());
}

export function* onFetchUserTypeDetails() {
  yield takeLatest(
    UserTypeActionTypes.FETCH_USERTYPE_DETAILS_START,
    fetchUserTypeData,
  );
}

export function* onFetchUserTypeResponseReset() {
  yield takeLatest(
    UserTypeActionTypes.FETCH_USERTYPE_DETAILS_RESPONSE_RESET,
    resetFetchUserTypeDetailsResponse,
  );
}
/** *********************  END FETCH USETYPE DETAILS ******************** */

export function* userTypeMasterSaga() {
  yield all([
    call(onCreateUserTypeDetails),
    call(onCreateUserTypeResponseReset),
    call(onUpdateUserTypeDetails),
    call(onUpdateUserTypeResponseReset),
    call(onGetUserTypeListDetails),
    call(onGetUserTypeListResponseReset),
    call(onFetchUserTypeDetails),
    call(onFetchUserTypeResponseReset),
    call(onDeleteUserTypeDetail),
    call(onDeleteUserTypeResponseReset),
  ]);
}
